import React from "react";
import { Space } from "antd";
import FilterTag from "../FilterTag";
import moment from "moment";

interface FilterBadgesProps<T = Record<string, any>> {
  filters: T;
  onRemoveFilter: (filterKey: keyof T) => void;
  onClearAllFilters: () => void;
  formatters?: Record<string, (value: any) => string>;
}

const FilterBadges = <T extends Record<string, any>>({
  filters,
  onRemoveFilter,
  onClearAllFilters,
  formatters = {},
}: FilterBadgesProps<T>) => {
  const defaultFormatters = {
    status: (value: string) => {
      if (value === "Active") return "Status: On";
      if (value === "Passive") return "Status: Off";
      return `Status: ${value}`;
    },
    startDate: (value: string) =>
      `Start date: ${moment(value).format("DD/MM/YYYY HH:mm")}`,
    endDate: (value: string) =>
      `End date: ${moment(value).format("DD/MM/YYYY HH:mm")}`,
  };

  const allFormatters = { ...defaultFormatters, ...formatters };

  const renderFilterBadges = () => {
    const badges: React.ReactNode[] = [];

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        const formatter = allFormatters[key as keyof typeof allFormatters];
        const displayText = formatter ? formatter(value) : `${key}: ${value}`;

        badges.push(
          <FilterTag
            key={key}
            closable
            onClose={() => onRemoveFilter(key as keyof T)}
          >
            {displayText}
          </FilterTag>
        );
      }
    });

    return badges;
  };

  const hasActiveFilters = Object.values(filters).some(
    (value) => value !== undefined && value !== null && value !== ""
  );

  if (!hasActiveFilters) {
    return null;
  }

  return (
    <div style={{ marginBottom: "16px" }}>
      <Space wrap>
        {renderFilterBadges()}
        <FilterTag onClick={onClearAllFilters}>Clear all</FilterTag>
      </Space>
    </div>
  );
};

export default FilterBadges;

